module.exports = __webpack_public_path__ + "static/media/luodiye_pc.aa4e560a.jpg";